var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(this.grade == 0)?_c('v-chip',{attrs:{"color":"red"}},[_vm._v(_vm._s(this.grade)+" ")]):_c('v-chip',{attrs:{"color":"success"}},[_vm._v(_vm._s(this.grade)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }